/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const kucunzhongxinRouter = {
	path: '/kucunzhongxin',
	component: Layout,
	redirect: 'noRedirect',
	name: '出入库',
	id: 1100000,
	meta: {
		title: '出入库',
		icon: 'component',
		roles: [1100000]
	},
	children: [
		// {
		// 	path: 'operation-process',
		// 	component: () => import('@/leniuview/stock/operation-process/index'),
		// 	name: '操作流程',
		// 	id: 1101000,
		// 	meta: {
		// 		title: '操作流程'
		// 	}
		// },
		{
			path: 'base',
			component: LayoutView,
			name: '基础信息',
			id: 1101000,
			meta: {
				title: '基础信息',
				roles: [1101000]
			},
			redirect: 'base',
			children: [
				{
					path: 'menudishtree',
					component: () => import('@/leniuview/menudish/menudishTree'),
					name: '原料',
					id: 1101100,
					meta: { title: '原料', roles: [1101100] }
				},
				{
					path: 'basic-config',
					component: () => import('@/leniuview/stock/basesetting/basic-config'),
					name: '基础配置',
					id: 1101100,
					meta: { title: '基础配置', roles: [1101100] }
				},
				{
					path: 'superDetail',
					component: () => import('@/leniuview/stock/basesetting/superDetail'),
					name: '商品',
					id: 1101400,
					meta: { title: '商品', roles: [1101400] }
				},
				{
					path: 'unit',
					component: () => import('@/leniuview/stock/basesetting/unit'),
					name: '单位',
					id: 1101200,
					meta: { title: '单位', roles: [1101200] }
				},
				{
					path: 'stockType',
					component: () => import('@/leniuview/stock/basesetting/stockType'),
					name: '仓库类别',
					id: 1101200,
					meta: { title: '仓库类别', roles: [1101200] }
				}
				//  菜单迁移栋库存下面
				// {
				// 	path: 'depotManage',
				// 	component: () => import('@/leniuview/stock/basesetting/depotManage'),
				// 	name: '仓库库存',
				// 	id: 1101300,
				// 	meta: { title: '仓库库存', roles: [1101300] }
				// },
				// {
				// 	path: 'depotManagedetail',
				// 	component: () =>
				// 		import('@/leniuview/stock/basesetting/depotManagedetail'),
				// 	name: '仓库管理详情',
				// 	meta: {
				// 		title: 'kucunzhongxin.depotManage',
				// 		roles: [1101300],
				// 		noCache: true
				// 	},
				// 	hidden: true
				// },
				// {
				// 	path: 'picidetail',
				// 	component: () => import('@/leniuview/stock/basesetting/picidetail'),
				// 	name: '批次详情',
				// 	meta: { title: '批次详情', noCache: true, roles: [1101300] },
				// 	hidden: true
				// },
				// {
				// 	path: 'totalStock',
				// 	component: () => import('@/leniuview/stock/basesetting/totalStock/index'),
				// 	name: '货品库存',
				// 	id: 1101300,
				// 	meta: { title: '货品库存', roles: [1101300] }
				// },
				// {
				// 	path: 'materialBidPrice',
				// 	component: () => import('@/leniuview/stock/basesetting/materialBidPrice'),
				// 	name: '原料中标价',
				// 	id: 1101300,
				// 	meta: { title: '原料中标价', noCache: true, roles: [1101300] }
				// }
			]
		},
		// {
		// 	path: 'supplier',
		// 	component: () => import('@/leniuview/purchase/layout'),
		// 	name: '供应商',
		// 	id: 1102000,
		// 	meta: {
		// 		title: '供应商',
		// 		roles: [1102000]
		// 	},
		// 	redirect: 'supplier',
		// 	children: [
		// 		{
		// 			path: 'supplierList',
		// 			component: () => import('@/leniuview/purchase/supplierList'),
		// 			name: '供应商级别',
		// 			id: 1102100,
		// 			meta: { title: 'caigouzhongxin.gongyinshangjibie', roles: [1102100] }
		// 		},
		// 		{
		// 			path: 'suppliermanage',
		// 			component: () => import('@/leniuview/purchase/supplier'),
		// 			name: '供应商管理',
		// 			id: 1102200,
		// 			meta: { title: '供应商管理', roles: [1102200] }
		// 		},
		// 		{
		// 			path: 'supplierDetail',
		// 			component: () =>
		// 				import(
		// 					/* webpackChunkName: "supplierDetail" */ '@/leniuview/purchase/supplierDetail'
		// 				),
		// 			name: '供应商资质',
		// 			meta: {
		// 				title: 'caigouzhongxin.supplierDetail',
		// 				noCache: true,
		// 				roles: [1102200]
		// 			},
		// 			hidden: true
		// 		},
		// 		{
		// 			path: 'singlesupply',
		// 			component: () => import('@/leniuview/purchase/singlesupply'),
		// 			name: '供货单',
		// 			id: 1102300,
		// 			meta: { title: '供货单', roles: [1102300] }
		// 		},
		// 		{
		// 			path: 'singlesupplydetail',
		// 			component: () =>
		// 				import('@/leniuview/purchase/singlesupply/singlesupplyDetail'),
		// 			name: '供货单详情',
		// 			meta: { title: '供货单详情', roles: [1102300], noCache: true },
		// 			hidden: true
		// 		},
		// 		{
		// 			path: 'quotation',
		// 			component: () => import('@/leniuview/purchase/quotation'),
		// 			name: '报价单',
		// 			id: 1102400,
		// 			meta: { title: '报价单', roles: [1102400], noCache: true }
		// 		},
		// 		{
		// 			path: 'quotationdetail',
		// 			component: () =>
		// 				import('@/leniuview/purchase/quotation/quotationDetail'),
		// 			name: '报价单详情',
		// 			meta: { title: '报价单详情', roles: [1102400], noCache: true },
		// 			hidden: true
		// 		}
		// 	]
		// },
		// 新供应商 start
		{
			path: 'supplierAdminister',
			component: LayoutView,
			name: '供应商管理',
			id: 1102000,
			meta: {
				title: '供应商管理',
				roles: [1102000]
			},
			redirect: 'supplierAdminister',
			children: [
				{
					path: 'supplier',
					component: () => import('@/leniuview/supplierManage/supplier/index'),
					name: '供应商',
					id: 1102200,
					meta: { title: '供应商', roles: [1102200] }
				},
				// {
				// 	path: 'supplyScore',
				// 	component: () => import('@/leniuview/supplierManage/supplyScore/index'),
				// 	name: '供应商评分',
				// 	id: 1102200,
				// 	meta: { title: '供应商评分', roles: [1102200] }
				// },
				{
					path: 'supplierRating',
					component: () => import('@/leniuview/supplierManage/supplyScore/supplierRating'),
					name: '供应商评分',
					id: 1102200,
					meta: { title: '供应商评分', roles: [1102200] }
				},
				{
					path: 'historicalRating',
					component: () => import('@/leniuview/supplierManage/supplyScore/historicalRating'),
					name: '历史评分',
					id: 1102200,
					hidden: true,
					meta: { title: '历史评分', noCache: true, roles: [1102200] }
				},
				{
					path: 'supplyScoreConfig',
					component: () => import('@/leniuview/supplierManage/supplyScore/supplyScoreConfig'),
					name: '供应评分配置',
					id: 1102200,
					hidden: true,
					meta: { title: '供应评分配置', roles: [1102200] }
				},
				{
					path: 'supplyStatistics',
					component: () => import('@/leniuview/supplierManage/supplyStatistics'),
					name: '供应商供货统计',
					id: 1102200,
					meta: { title: '供应商供货统计', roles: [1102200] }
				},
				{
					path: 'qualification',
					component: () => import('@/leniuview/supplierManage/qualificationComparison'),
					name: '供应商资质对比',
					id: 1102200,
					meta: { title: '供应商资质对比', roles: [1102200] }
				}
			]
		},
		// {
		// 	path: 'purchase',
		// 	component: () => import('@/leniuview/purchase/layout'),
		// 	name: '采购',
		// 	id: 1103000,
		// 	meta: {
		// 		title: '采购',
		// 		roles: [1103000]
		// 	},
		// 	redirect: 'purchase',
		// 	children: [
		// 		{
		// 			path: 'caigougenerate',
		// 			component: () =>
		// 				import('@/leniuview/purchase/purchaseplan/purchaselist'),
		// 			name: '采购单',
		// 			id: 1103100,
		// 			meta: { title: '采购单', roles: [1103100] }
		// 		},
		// 		{
		// 			path: 'purchaselistDetail',
		// 			component: () =>
		// 				import('@/leniuview/purchase/purchaseplan/purchaselistDetail'),
		// 			name: '采购计划详情',
		// 			meta: {
		// 				title: 'caigouzhongxin.purchaselistDetail',
		// 				roles: [1103100],
		// 				noCache: true
		// 			},
		// 			hidden: true
		// 		},
		// 		{
		// 			path: 'emaillist',
		// 			component: () =>
		// 				import('@/leniuview/purchase/purchaseplan/emaillist'),
		// 			name: '采购通知记录',
		// 			id: 1103300,
		// 			meta: {
		// 				title: 'caigouzhongxin.emaillist',
		// 				roles: [1103300]
		// 			}
		// 		},
		// 		{
		// 			path: 'inquiry',
		// 			component: () => import('@/leniuview/purchase/inquiry'),
		// 			name: '询价单',
		// 			id: 1103200,
		// 			meta: { title: '询价单', roles: [1103200] }
		// 		},
		// 		{
		// 			path: 'inquirydetail',
		// 			component: () => import('@/leniuview/purchase/inquiry/inquiryDetail'),
		// 			name: '询价单详情',
		// 			meta: { title: '询价单详情', roles: [1103200], noCache: true },
		// 			hidden: true
		// 		},
		// 		{
		// 			path: 'firmPrice',
		// 			component: () => import('@/leniuview/purchase/firmPrice'),
		// 			name: '决标',
		// 			meta: { title: '决标', roles: [1103200], noCache: true },
		// 			hidden: true
		// 		},
		// 		{
		// 			path: 'firmPricedetail',
		// 			component: () =>
		// 				import('@/leniuview/purchase/firmPrice/firmPriceDetail'),
		// 			name: '决标详情',
		// 			meta: { title: '决标详情', roles: [1103200], noCache: true },
		// 			hidden: true
		// 		}
		// 	]
		// },
		// 新采购模块路由 start
		{
			path: 'purchaseManage',
			component: LayoutView,
			name: '采购管理',
			id: 1103000,
			meta: {
				title: '采购管理',
				roles: [1103000]
			},
			redirect: 'purchaseManage',
			children: [
				{
					path: 'materialBidPrice',
					component: () => import('@/leniuview/stock/basesetting/materialBidPrice'),
					name: '货品中标价',
					id: 1101300,
					meta: { title: '货品中标价', noCache: true, roles: [1101300] }
				},
				{
					path: 'inquiry-goods-addEdit',
					component: () => import('@/leniuview/purchase/inquiry-goods/addEdit'),
					name: '货品招标新增',
					id: 1103200,
					hidden: true,
					meta: { title: '货品招标新增', noCache: true, roles: [1103200] }
				},
				{
					path: 'inquiry-goods',
					component: () => import('@/leniuview/purchase/inquiry-goods'),
					name: '货品招标',
					id: 1103200,
					meta: { title: '货品招标', noCache: true, roles: [1103200] }
				},
				{
					path: 'inquiry-goods-info',
					component: () => import('@/leniuview/purchase/inquiry-goods/detail'),
					name: '货品招标详情',
					id: 1103200,
					hidden: true,
					meta: { title: '货品招标详情', noCache: true, roles: [1103200] }
				},
				{
					path: 'viewGoodsQuote',
					component: () => import('@/leniuview/purchase/inquiry-goods/viewQuote'),
					name: '查看报价',
					meta: { title: '查看报价', roles: [1103200], noCache: true },
					hidden: true
				},
				{
					path: 'quotation-comparison',
					component: () => import('@/leniuview/purchase/inquiry-goods/comparison'),
					name: '报价对比',
					id: 1103200,
					hidden: true,
					meta: {
						title: '报价对比',
						noCache: true
					}
				},
				{
					path: 'production-plan',
					component: () => import(/* webpackChunkName: "production-plan" */ '@/leniuview/purchase/production-plan/index'),
					name: '生产计划',
					id: 1103100,
					meta: { title: '生产计划', roles: [1103100] }
				},
				{
					path: 'production-order',
					component: () => import(/* webpackChunkName: "production-order" */ '@/leniuview/purchase/production-order/index'),
					name: '采购计划',
					id: 1103100,
					meta: { title: '采购计划', roles: [1103100] }
				},
				{
					path: 'production-addEdit',
					component: () => import(/* webpackChunkName: "production-addEdit" */ '@/leniuview/purchase/production-order/addEdit'),
					name: '采购计划新增/编辑',
					id: 1103100,
					hidden: true,
					meta: { title: '采购计划新增/编辑', noCache: true }
				},
				{
					path: 'production-detail',
					component: () => import(/* webpackChunkName: "production-detail" */ '@/leniuview/purchase/production-order/detail'),
					name: '采购计划详情',
					id: 1103100,
					hidden: true,
					meta: { title: '采购计划详情', noCache: true }
				},
				{
					path: 'inquiry',
					component: () => import('@/leniuview/purchase/inquiry'),
					name: '采购询价',
					id: 1103200,
					meta: { title: '采购询价', roles: [1103200] }
				},
				{
					path: 'inquirydetail',
					component: () => import('@/leniuview/purchase/inquiry/inquiryDetail'),
					name: '采购询价新增/编辑',
					meta: { title: '采购询价新增/编辑', roles: [1103200], noCache: true },
					hidden: true
				},
				{
					path: 'inquiry-addEdit',
					component: () => import('@/leniuview/purchase/inquiry/addEdit'),
					name: '采购询价新增/编辑',
					meta: { title: '采购询价新增/编辑', roles: [1103200], noCache: true },
					hidden: true
				},
				{
					path: 'inquiry-detail',
					component: () => import('@/leniuview/purchase/inquiry/detail'),
					name: '采购询价单详情',
					meta: { title: '采购询价单详情', roles: [1103200], noCache: true },
					hidden: true
				},
				// {
				// 	path: 'firmPrice',
				// 	component: () => import('@/leniuview/purchase/firmPrice'),
				// 	name: '决标',
				// 	meta: { title: '决标', roles: [1103200], noCache: true },
				// 	hidden: true
				// },
				{
					path: 'inquiry-viewQuote',
					component: () => import('@/leniuview/purchase/inquiry/viewQuote'),
					name: '查看报价',
					meta: { title: '查看报价', roles: [1103200], noCache: true },
					hidden: true
				},
				{
					path: 'quotationDetails',
					component: () => import('@/leniuview/purchase/inquiry/quotationDetails'),
					name: '报价明细',
					meta: { title: '报价明细', roles: [1103200], noCache: true },
					hidden: true
				},
				{
					path: 'firmPricedetail',
					component: () =>
						import('@/leniuview/purchase/firmPrice/firmPriceDetail'),
					name: '供应商报价明细对比',
					meta: { title: '供应商报价明细对比', roles: [1103200], noCache: true },
					hidden: true
				},
				{
					path: 'purchase-order',
					component: () => import(/* webpackChunkName: "purchase-order" */ '@/leniuview/purchase/purchase-order/index'),
					name: '采购订单',
					id: 1103100,
					meta: { title: '采购订单', roles: [1103100], noCache: true }
				},
				{
					path: 'purchase-addEdit',
					component: () => import(/* webpackChunkName: "purchase-addEdit" */ '@/leniuview/purchase/purchase-order/addEdit'),
					name: '采购订单新增/编辑',
					id: 1103100,
					hidden: true,
					meta: { title: '采购订单新增/编辑', noCache: true }
				}
				// {
				// 	path: 'inspection-order',
				// 	component: () => import(/* webpackChunkName: "inspection-order" */ '@/leniuview/purchase/inspection-order/index'),
				// 	name: '采购验货',
				// 	id: 1103100,
				// 	meta: { title: '采购验货', roles: [1103100], noCache: true }
				// },
				// {
				// 	path: 'inspection-addEdit',
				// 	component: () => import(/* webpackChunkName: "inspection-addEdit" */ '@/leniuview/purchase/inspection-order/addEdit'),
				// 	name: '采购验货新增/编辑',
				// 	id: 1103100,
				// 	hidden: true,
				// 	meta: { title: '采购验货新增/编辑', noCache: true }
				// },
				// {
				// 	path: 'inspection-detail',
				// 	component: () => import(/* webpackChunkName: "inspection-detail" */ '@/leniuview/purchase/inspection-order/detail'),
				// 	name: '采购验货详情',
				// 	id: 1103100,
				// 	hidden: true,
				// 	meta: { title: '采购验货详情', noCache: true }
				// }
			]
		},
		{
			path: 'stockinout',
			component: LayoutView,
			name: '库存',
			id: 1104000,
			meta: {
				title: '库存',
				roles: [1104000]
			},
			redirect: 'stockinout',
			children: [
				{
					path: 'depotManage',
					component: () => import('@/leniuview/stock/basesetting/depotManage'),
					name: '仓库库存',
					id: 1101300,
					meta: { title: '仓库库存', roles: [1101300] }
				},
				{
					path: 'totalStock',
					component: () => import('@/leniuview/stock/basesetting/totalStock/index'),
					name: '货品库存',
					id: 1101300,
					meta: { title: '货品库存', roles: [1101300] }
				},
				{
					path: 'depotManagedetail',
					component: () =>
						import('@/leniuview/stock/basesetting/depotManagedetail'),
					name: '仓库管理详情',
					meta: {
						title: 'kucunzhongxin.depotManage',
						roles: [1101300],
						noCache: true
					},
					hidden: true
				},
				{
					path: 'picidetail',
					component: () => import('@/leniuview/stock/basesetting/picidetail'),
					name: '批次详情',
					meta: { title: '批次详情', noCache: true, roles: [1101300] },
					hidden: true
				},
				{
					path: 'warehousing',
					component: () => import('@/leniuview/stock/warehousing/warehousing'),
					name: '入库管理',
					id: 1104100,
					meta: { title: '入库管理', noCache: true, roles: [1104100] }
				},
				{
					path: 'warehouse-addEdit',
					component: () => import('@/leniuview/stock/warehousing/addEdit'),
					name: '入库新增/编辑',
					id: 1104100,
					hidden: true,
					meta: { title: '入库新增/编辑', noCache: true, roles: [1104100] }
				},
				{
					path: 'warehousedetail',
					component: () =>
						import('@/leniuview/stock/warehousing/warehousedetail'),
					name: '入库单详情',
					meta: { title: '入库单详情', noCache: true, roles: [1104100] },
					hidden: true
				},
				{
					path: 'warehouse-detail',
					component: () =>
						import('@/leniuview/stock/warehousing/detail'),
					name: '入库单详情',
					meta: { title: '入库单详情', noCache: true, roles: [1104100] },
					hidden: true
				},
				{
					path: 'warehouse-importresult',
					component: () => import('@/leniuview/stock/warehousing/importresult'),
					name: '导入结果',
					meta: {
						title: 'kucunzhongxin.importresult',
						noCache: true,
						roles: [1104100]
					},
					hidden: true
				},
				{
					path: 'outhousing',
					component: () => import('@/leniuview/stock/outofstock/outhousing'),
					name: '出库管理',
					id: 1104200,
					meta: { title: '出库管理', noCache: true, roles: [1104200] }
				},
				{
					path: 'outhousing-addEdit',
					component: () => import('@/leniuview/stock/outofstock/addEdit'),
					name: '出库单新增/编辑',
					id: 1104200,
					hidden: true,
					meta: { title: '出库单新增/编辑', noCache: true, roles: [1104200] }
				},
				{
					path: 'outhouse-detail',
					component: () =>
						import('@/leniuview/stock/outofstock/detail'),
					name: '出库单详情',
					meta: { title: '出库单详情', noCache: true, roles: [1104200] },
					hidden: true
				},
				{
					path: 'outhousedetail',
					component: () =>
						import('@/leniuview/stock/outofstock/outhousedetail'),
					name: '出库单详情',
					meta: { title: '出库单详情', noCache: true, roles: [1104200] },
					hidden: true
				},
				{
					path: 'inventory-count',
					component: () => import('@/leniuview/stock/pandian/index'),
					name: '库存盘点',
					id: 1105100,
					meta: { title: '库存盘点', roles: [1105100] }
				},
				{
					path: 'inventory-addEdit',
					component: () => import('@/leniuview/stock/pandian/addEdit'),
					name: '盘点单新增/编辑',
					id: 1105100,
					hidden: true,
					meta: { title: '盘点单新增/编辑', noCache: true, roles: [1105100] }
				},
				{
					path: 'inventory-detail',
					component: () => import('@/leniuview/stock/pandian/detail'),
					name: '库存盘点详情',
					id: 1105100,
					hidden: true,
					meta: { title: '库存盘点详情', noCache: true, roles: [1105100] }
				},
				{
					path: 'pandiandetail',
					component: () => import('@/leniuview/stock/pandian/pandiandetail'),
					name: '盘点详情',
					meta: { title: '盘点详情', noCache: true, roles: [1105100] },
					hidden: true
				},
				{
					path: 'frmLossOverflow',
					component: () => import('@/leniuview/stock/frmLossOverflowOrder/index'),
					name: '报损报溢',
					id: 1105100,
					meta: { title: '报损报溢', roles: [1105100] }
				},
				{
					path: 'frmLossdetail',
					component: () => import('@/leniuview/stock/frmLossOverflowOrder/detail'),
					name: '报损报溢单详情',
					meta: { title: '报损报溢单详情', noCache: true, roles: [1105100] },
					hidden: true
				},
				{
					path: 'kucunyujing',
					component: () =>
						import('@/leniuview/stock/statisticaltable/kucunyujing'),
					name: '库存预警',
					id: 1106100,
					meta: {
						title: '库存预警',
						roles: [1106100]
					}
				},
				{
					path: 'guoqiyujing',
					component: () =>
						import('@/leniuview/stock/statisticaltable/guoqiyujing'),
					name: '过期预警',
					id: 1106200,
					meta: {
						title: '过期预警',
						roles: [1106200]
					}
				}
			]
		},
		// {
		// 	path: 'pandian',
		// 	component: () => import('@/leniuview/stock/pandian/layout'),
		// 	name: '盘点',
		// 	id: 1105000,
		// 	meta: {
		// 		title: 'kucunzhongxin.pandian',
		// 		roles: [1105000]
		// 	},
		// 	redirect: 'pandian',
		// 	children: [
		// 		{
		// 			path: 'index',
		// 			component: () => import('@/leniuview/stock/pandian/index'),
		// 			name: '盘点单',
		// 			id: 1105100,
		// 			meta: { title: '盘点单', roles: [1105100] }
		// 		},
		// 		{
		// 			path: 'pandiandetail',
		// 			component: () => import('@/leniuview/stock/pandian/pandiandetail'),
		// 			name: '盘点详情',
		// 			meta: { title: '盘点详情', noCache: true, roles: [1105100] },
		// 			hidden: true
		// 		},
		// 		{
		// 			path: 'frmLossOverflow',
		// 			component: () => import('@/leniuview/stock/frmLossOverflowOrder/index'),
		// 			name: '报损报溢单',
		// 			id: 1105100,
		// 			meta: { title: '报损报溢单', roles: [1105100] }
		// 		},
		// 		{
		// 			path: 'frmLossdetail',
		// 			component: () => import('@/leniuview/stock/frmLossOverflowOrder/detail'),
		// 			name: '报损报溢单详情',
		// 			meta: { title: '报损报溢单详情', noCache: true, roles: [1105100] },
		// 			hidden: true
		// 		}
		// 	]
		// },
		// {
		// 	path: 'earlywarning',
		// 	component: () => import('@/leniuview/stock/statisticaltable/layout'),
		// 	name: '预警',
		// 	id: 1106000,
		// 	meta: {
		// 		title: '预警',
		// 		roles: [1106000]
		// 	},
		// 	redirect: 'earlywarning',
		// 	children: [
		// 		{
		// 			path: 'kucunyujing',
		// 			component: () =>
		// 				import('@/leniuview/stock/statisticaltable/kucunyujing'),
		// 			name: '库存预警',
		// 			id: 1106100,
		// 			meta: {
		// 				title: '库存预警',
		// 				roles: [1106100]
		// 			}
		// 		},
		// 		{
		// 			path: 'guoqiyujing',
		// 			component: () =>
		// 				import('@/leniuview/stock/statisticaltable/guoqiyujing'),
		// 			name: '过期预警',
		// 			id: 1106200,
		// 			meta: {
		// 				title: '过期预警',
		// 				roles: [1106200]
		// 			}
		// 		}
		// 	]
		// },
		{
			path: 'statisticaltable',
			component: LayoutView,
			name: '库存报表',
			id: 1107000,
			meta: {
				title: '库存报表',
				roles: [1107000]
			},
			redirect: 'statisticaltable',
			children: [
				{
					path: 'gongyingshangtongji',
					component: () =>
						import('@/leniuview/stock/statisticaltable/gongyingshangtongji'),
					name: '供应商供货统计表',
					id: 1107100,
					meta: {
						title: '供应商供货统计表',
						roles: [1107100]
					}
				},
				{
					path: 'gongyingmingxi',
					component: () =>
						import('@/leniuview/stock/statisticaltable/gongyingmingxi'),
					name: '供应明细表',
					meta: {
						title: '供应明细表',
						noCache: true,
						roles: [1107100]
					},
					hidden: true
				},
				{
					path: 'fenleihuizong',
					component: () =>
						import('@/leniuview/stock/statisticaltable/fenleihuizong'),
					name: '类别出入库表',
					id: 1107200,
					meta: {
						title: '类别出入库表',
						roles: [1107200]
					}
				},
				{
					path: 'fenleihuizongdan',
					component: () =>
						import('@/leniuview/stock/statisticaltable/fenleihuizongdan'),
					name: '原料单品出入库表',
					id: 1107300,
					meta: {
						title: '原料单品出入库表',
						roles: [1107300]
					}
				},
				// {
				//   path: "costAnalysis",
				//   component: () =>
				//     import(/* webpackChunkName: "" */"@/leniuview/stock/statisticaltable/costAnalysis"),
				//   name: "餐次出库成本分析表",
				//   id: 1106400,
				//   meta: {
				//     title: "餐次出库成本分析表",
				//     roles: [1106400]
				//   }
				// },
				{
					path: 'monthcaigoudetail',
					component: () =>
						import(
							/* webpackChunkName: "monthcaigoudetail" */ '@/leniuview/stock/statisticaltable/monthcaigoudetail'
						),
					name: '原料日度出入库汇总表',
					id: 1107400,
					meta: {
						title: '原料日度出入库汇总表',
						roles: [1107400]
					}
				},
				{
					path: 'pandianchayi',
					component: () => import('@/leniuview/stock/pandian/pandianchayi'),
					name: '盘点差异分析表',
					id: 1107500,
					meta: {
						title: '盘点差异分析表',
						roles: [1107500]
					}
				},
				{
					path: 'stockInStatistics',
					component: () => import('@/leniuview/stock/statisticaltable/stockStatistics/stockInStatistics'),
					name: '仓库入库明细',
					id: 1107500,
					meta: {
						title: '仓库入库明细',
						roles: [1107500]
					}
				},
				{
					path: 'deliveryStatistics',
					component: () => import('@/leniuview/stock/statisticaltable/stockStatistics/deliveryStatistics'),
					name: '仓库出库明细',
					id: 1107500,
					meta: {
						title: '仓库出库明细',
						roles: [1107500]
					}
				},
				{
					path: 'warehouseSummary',
					component: () => import('@/leniuview/stock/statisticaltable/stockStatistics/warehouseSummary'),
					name: '仓库入库汇总',
					id: 1107500,
					meta: {
						title: '仓库入库汇总',
						roles: [1107500]
					}
				},
				{
					path: 'proportionFoodMaterials',
					component: () => import('@/leniuview/stock/statisticaltable/stockStatistics/proportionFoodMaterials'),
					name: '各仓库食材占比',
					id: 1107500,
					meta: {
						title: '各仓库食材占比',
						roles: [1107500]
					}
				},
				{
					path: 'foodMaterialCostStatistics',
					component: () => import('@/leniuview/stock/statisticaltable/stockStatistics/foodMaterialCostStatistics'),
					name: '各仓库食材费用统计表',
					id: 1107500,
					meta: {
						title: '各仓库食材费用统计表',
						roles: [1107500]
					}
				},
				{
					path: 'historicalInventory',
					component: () => import('@/leniuview/stock/statisticaltable/stockStatistics/historicalInventory'),
					name: '历史库存表',
					id: 1107500,
					meta: {
						title: '历史库存表',
						roles: [1107500]
					}
				}
			]
		},
		{
			path: 'supplierFunction',
			component: LayoutView,
			name: '供应商功能',
			id: 1107000,
			meta: {
				title: '供应商功能'
			},
			redirect: 'supplierFunction',
			children: [
				{
					path: 'supplierQuotation',
					component: () =>
						import('@/leniuview/stock/supplierFunction/supplierQuotation/index'),
					name: '采购询价报价',
					id: 1107101,
					meta: {
						title: '采购询价报价',
						noCache: true
					}
				},
				{
					path: 'supplierQuotation-detail',
					component: () => import('@/leniuview/stock/supplierFunction/supplierQuotation/detail'),
					name: '采购询价报价详情',
					id: 1107102,
					hidden: true,
					meta: {
						title: '采购询价报价详情',
						noCache: true
					}
				},
				{
					path: 'goods-quotation',
					component: () =>
						import('@/leniuview/stock/supplierFunction/goods-quotation/index'),
					name: '货品招标报价',
					id: 1107101,
					meta: {
						title: '货品招标报价',
						noCache: true
					}
				},
				{
					path: 'goods-viewQuote',
					component: () => import('@/leniuview/stock/supplierFunction/goods-quotation/viewQuote'),
					name: '查看报价',
					id: 1107102,
					hidden: true,
					meta: {
						title: '查看报价',
						noCache: true
					}
				},
				{
					path: 'intention-quote',
					component: () => import('@/leniuview/stock/supplierFunction/goods-quotation/IntentionQuote'),
					name: '意向报价',
					id: 1107102,
					hidden: true,
					meta: {
						title: '意向报价',
						noCache: true
					}
				},
				{
					path: 'goods-quotation-detail',
					component: () => import('@/leniuview/stock/supplierFunction/goods-quotation/quote-detail'),
					name: '报价明细',
					id: 1107102,
					hidden: true,
					meta: {
						title: '报价明细',
						noCache: true
					}
				},
				{
					path: 'supplier-quotation-detail',
					component: () => import('@/leniuview/stock/supplierFunction/goods-quotation/detail'),
					name: '报价详情',
					id: 1107102,
					hidden: true,
					meta: {
						title: '报价详情',
						noCache: true
					}
				},
				{
					path: 'supplier-purchaseOrder',
					component: () =>
						import('@/leniuview/stock/supplierFunction/purchaseOrder/index'),
					name: '采购订单',
					id: 1107103,
					meta: {
						title: '采购订单',
						noCache: true
					}
				},
				{
					path: 'supplier-purchaseOrder-detail',
					component: () => import('@/leniuview/stock/supplierFunction/purchaseOrder/detail'),
					name: '采购订单详情',
					id: 1107104,
					hidden: true,
					meta: {
						title: '采购订单详情',
						noCache: true
					}
				},
				{
					path: 'supplier-purchaseOrder-disassemble',
					component: () => import('@/leniuview/stock/supplierFunction/purchaseOrder/disassemble'),
					name: '拆解',
					id: 1107104,
					hidden: true,
					meta: {
						title: '拆解',
						noCache: true
					}
				},
				{
					path: 'supplier-inspectionOrder',
					component: () => import('@/leniuview/stock/supplierFunction/inspectionOrder/index'),
					name: '送货订单',
					id: 1107105,
					meta: {
						title: '送货订单',
						noCache: true
					}
				},
				{
					path: 'supplier-inspectionOrder-detail',
					component: () => import('@/leniuview/stock/supplierFunction/inspectionOrder/detail'),
					name: '送货订单详情',
					id: 1107104,
					hidden: true,
					meta: {
						title: '送货订单详情',
						noCache: true
					}
				},
				{
					path: 'supplier-supply-statistics',
					component: () =>
						import('@/leniuview/stock/supplierFunction/supplyStatistics/index'),
					name: '供货情况统计',
					id: 1107103,
					meta: {
						title: '供货情况统计',
						noCache: true
					}
				}
			]
		}
	]
}

export default kucunzhongxinRouter
